function ArrowDown(props) {
    return (
        <svg className={`${props.className}`} aria-hidden="true"
             fill="none"
             viewBox="0 0 10 6">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"
                  d="m1 1 4 4 4-4"/>
        </svg>
    )
}

export default ArrowDown